var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1420_10298)","key":0},[React.createElement("rect",{"x":"-0.00146484","y":"30.3154","width":"42.8727","height":"2.38181","rx":"1.19091","transform":"rotate(-45 -0.00146484 30.3154)","fill":"#0092FF","key":0}),React.createElement("rect",{"x":"1.68604","y":"0.000244141","width":"42.8727","height":"2.38181","rx":"1.19091","transform":"rotate(45 1.68604 0.000244141)","fill":"#0092FF","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1420_10298"},React.createElement("rect",{"width":"32","height":"32","fill":"white"})))]);
}

Close.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Close;

Close.default = Close;
